import React, { useState, useEffect, createContext } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/HomePage/Header/Header';
import Footer from './components/HomePage/Footer/Footer';
import GoogleMapComponent from './components/Maps/GoogleMapComponent';
import LandingPage from './components/HomePage/MainBody/MainBody';
import About from './components/HomePage/About/About';
import Developing from './components/HomePage/Developing/Developing';
import Newsletter from './components/HomePage/Newsletter/Newsletter';
import Contact from './components/HomePage/Contact/Contact';
import logVisitor from './components/API/Logger';
import UnsubscribePage from './components/Unsubscribe/unsubscribe';
import Login from './components/Auth/Login/Login';
import CreateAccount from './components/Auth/CreateAccount/CreateAccount';
import ForgotPassword from './components/Auth/ForgotPassword/ForgotPassword';
import PasswordReset from './components/Auth/PasswordReset/PasswordReset';
import EmailVerification from './components/Auth/EmailVerification/EmailVerification';
import { refreshCsrfToken } from './services/csrfTokenManager';
import checkLoginStatusAPI from './components/API/checkLoginStatus';
import Dashboard from './components/Dashboard/Dashboard';
import ChurchUpdatePage from './components/ChurchUpdatePage/ChurchUpdatePage';
import AdminDashboard from './components/Admin/AdminDashboard/AdminDashboard';

import ListBooks from './Store/components/Books/ListBooks';
import AddEditBook from './Store/components/Books/AddEditBook';
import ListCategories from './Store/components/Categories/ListCategories';
import AddEditCategory from './Store/components/Categories/AddEditCategory';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';


//import Sidebarmenu from './components/Library/sidebar-menu/sidebar-menu';
//<Route path="/Sidebarmenu" element={<Sidebarmenu />} />

//          
import './App.css';

export const AuthContext = createContext();

function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const updateLoginStatus = (status) => {
    setIsLoggedIn(status);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, updateLoginStatus }}>
      {children}
    </AuthContext.Provider>
  );
}

function ConditionalFooter() {
  const location = useLocation();
  const noFooterRoutes = ['/dashboard', '/admindash', '/sidebarmenu']; // Add more routes here if needed

  if (noFooterRoutes.includes(location.pathname)) {
    return null;
  }

  return <Footer />;
}

function AppContent() {
  const { updateLoginStatus } = React.useContext(AuthContext);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        await refreshCsrfToken();
        logVisitor();

        const loginStatus = await checkLoginStatusAPI();
        updateLoginStatus(loginStatus.isLoggedIn);

        const refreshInterval = setInterval(refreshCsrfToken, 25 * 60 * 1000);

        return () => clearInterval(refreshInterval);
      } catch (error) {
        console.error('Error initializing app:', error);
      }
    };

    initializeApp();
  }, [updateLoginStatus]);

  return (
    <div className="App" style={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <Header />
      <main style={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/maps" element={<GoogleMapComponent />} />
          <Route path="/about" element={<About />} />
          <Route path="/developing" element={<Developing />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/church-update" element={<ChurchUpdatePage />} />

          <Route path="/admindash" element={<AdminDashboard />} />
          <Route path="/admin/books" element={<ListBooks />} />
          <Route path="/admin/books/add" element={<AddEditBook />} />
          <Route path="/admin/books/edit/:id" element={<AddEditBook />} />
          <Route path="/admin/categories" element={<ListCategories />} />
          <Route path="/admin/categories/add" element={<AddEditCategory />} />
          <Route path="/admin/categories/edit/:id" element={<AddEditCategory />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>
      <ConditionalFooter />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;